// import { useSeasonsAndEpisodesToya } from '@/clients/toya/features/VOD/hooks/useSeasonsAndEpisodesToya'
// import { useSeasonsAndEpisodesStreamIQ } from '@/clients/streamiq/features/VOD/hooks/useSeasonsAndEpisodesStreamIQ'
import { isStreamIQ, isToya } from '@/shared/lib'

export const getSeasonsAndEpisodes = async () => {
    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/features/VOD/hooks/useSeasonsAndEpisodesToya')

            // return module.useSeasonsAndEpisodesToya as typeof useSeasonsAndEpisodesToya
            return module.useSeasonsAndEpisodesToya
        } catch (error) {
            console.warn(
                'useSearchResultsToya module is missing. TOYA-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/streamiq/features/VOD/hooks/useSeasonsAndEpisodesStreamIQ')

            // return module.useSeasonsAndEpisodesStreamIQ as typeof useSeasonsAndEpisodesStreamIQ
            return module.useSeasonsAndEpisodesStreamIQ
        } catch (error) {
            console.warn(
                'useSeasonsAndEpisodesStreamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
